import React from 'react';
import { useLocale } from '../../../../contexts/LocaleContext';
import './Features.css';

const Features: React.FC = () => {
  const { t } = useLocale();

  const features = [
    {
      icon: 'fas fa-file-pdf',
      title: t('featureAInstein1Title'),
      description: t('featureAInstein1Description')
    },
    {
      icon: 'fas fa-photo-film',
      title: t('featureAInstein2Title'),
      description: t('featureAInstein2Description')
    },
    {
      icon: 'fas fa-language',
      title: t('featureAInstein3Title'),
      description: t('featureAInstein3Description')
    },
    {
      icon: 'fas fa-chart-line',
      title: t('featureAInstein4Title'),
      description: t('featureAInstein4Description')
    },
    {
      icon: 'fas fa-repeat',
      title: t('featureAInstein5Title'),
      description: t('featureAInstein5Description')
    }
  ];

  return (
    <section className="features-section">
      <div className="container">
        <h2>{t('featuresAInsteinTitle')}</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <i className={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
